/* Bull Ring Fabrics: swipe a bag item left or right to remove it (mini bag, phones and desktop). Added 2026-10-23 for Abid.
   Loaded from snippets/brf-bag-aurora.liquid. Drag a row sideways: a red "Remove" strip shows behind it; let go past the
   line (or flick) and the row slides away, folds shut and the theme's own remove button is pressed (so the undo pill still works).
   Short drags spring back. Taps, scrolling and the +/- buttons work as before.
   2026-10-24 (Abid): swiping left to right now saves the item to the wishlist instead of removing it: the strip behind turns
   green with a heart and "Save to wishlist", the row springs back, the heart pops and a small "Saved to your wishlist - View"
   note shows (the item stays in the bag). Right to left still removes. Uses window.brfWl from brf-wishlist.js.
   2026-10-24 (later): on phones a thumb swipe to the right curves a little, so the bag list started scrolling part-way
   through and the phone cancelled the swipe (the row sprang back, nothing saved). Once a row is being swiped the list
   now stays still, a save that the phone cancels at the last moment still counts, a shorter swipe (a quarter of the row)
   saves, and a flick is judged on the finger's speed at the end of the swipe.
   Removing an item (swipe, bin or Remove) now ends in the same slide-away: the row slips out, blurs and shrinks with a
   little puff, and the items below glide up to close the gap before the bag updates (see the second block below). */
(function () {
  if (window.__brfSwipeRm) return; window.__brfSwipeRm = 1;
  var doc = document;
  var ROW = '#mini-cart .mini-cart__line-item';
  var BIN = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"/><path d="M9.5 7V5.2c0-.7.5-1.2 1.2-1.2h2.6c.7 0 1.2.5 1.2 1.2V7"/><path d="M6.5 7l.9 11.6c.1 1 .9 1.9 2 1.9h5.2c1.1 0 1.9-.8 2-1.9L17.5 7"/></svg>';
  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M12 20.6s-7.6-4.6-9.3-9.4C1.6 8 3.5 4.6 7 4.6c2 0 3.6 1.1 5 3 1.4-1.9 3-3 5-3 3.5 0 5.4 3.4 4.3 6.6-1.7 4.8-9.3 9.4-9.3 9.4z"/></svg>';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css = doc.createElement('style');
  css.textContent =
    ROW + '{touch-action:pan-y;position:relative}' +
    ROW + '.is-swiping{z-index:2;background:#fff;border-radius:16px;box-shadow:0 6px 18px -10px rgba(29,29,31,.35);cursor:grabbing;user-select:none;-webkit-user-select:none}' +
    ROW + '.is-swiping *{pointer-events:none}' +
    '.brf-swipe-bg{position:absolute;z-index:1;display:flex;align-items:center;border-radius:16px;pointer-events:none;color:#C4343B;' +
      'background:rgba(229,72,77,.10);transition:background-color .2s ease,color .2s ease;font:600 13px/1 inherit;letter-spacing:.01em}' +
    '.brf-swipe-bg__in{display:flex;align-items:center;gap:7px;padding:0 20px;transition:transform .25s cubic-bezier(.3,1.6,.4,1)}' +
    '.brf-swipe-bg.is-l{justify-content:flex-end}.brf-swipe-bg.is-r{justify-content:flex-start}' +
    '.brf-swipe-bg.is-armed{background:#E5484D;color:#fff}.brf-swipe-bg.is-armed .brf-swipe-bg__in{transform:scale(1.08)}' +
    '.brf-swipe-hint{animation:brfSwipeHint 1.1s cubic-bezier(.4,0,.2,1) .35s 1 both}' +
    '@keyframes brfSwipeHint{0%,100%{transform:none}40%,55%{transform:translateX(-34px)}}' +
    /* left to right: save to wishlist */
    '.brf-swipe-bg .brf-swipe-bg__wl{display:none}.brf-swipe-bg.is-r .brf-swipe-bg__wl{display:flex}.brf-swipe-bg.is-r .brf-swipe-bg__rm{display:none}' +
    '.brf-swipe-bg.is-r{color:#0F7A43;background:rgba(20,153,84,.10)}.brf-swipe-bg.is-r.is-armed{background:#149954;color:#fff}' +
    '.brf-swipe-bg.is-saved .brf-swipe-bg__wl svg{animation:brfSwipeHeart .5s cubic-bezier(.3,1.8,.4,1)}' +
    '@keyframes brfSwipeHeart{0%{transform:scale(1)}40%{transform:scale(1.45)}100%{transform:scale(1)}}' +
    '.brf-swipe-wl{position:fixed;left:50%;bottom:calc(20px + env(safe-area-inset-bottom));z-index:2147483001;display:flex;align-items:center;gap:10px;max-width:calc(100vw - 32px);' +
      'padding:10px 10px 10px 16px;border-radius:999px;background:rgba(29,29,31,.86);color:#fff!important;text-decoration:none!important;font:500 14px/1.3 inherit;' +
      '-webkit-backdrop-filter:blur(18px) saturate(170%);backdrop-filter:blur(18px) saturate(170%);box-shadow:inset 0 1px 0 rgba(255,255,255,.12),0 14px 34px -12px rgba(0,0,0,.5);' +
      'opacity:0;transform:translate(-50%,24px) scale(.96);pointer-events:none;transition:opacity .25s ease,transform .4s cubic-bezier(.3,1.4,.4,1)}' +
    '.brf-swipe-wl.is-in{opacity:1;transform:translate(-50%,0) scale(1);pointer-events:auto}' +
    '.brf-swipe-wl svg{flex:0 0 auto;width:18px;height:18px;color:#FF6B8A}' +
    '.brf-swipe-wl b{flex:0 0 auto;padding:7px 13px;border-radius:999px;background:#fff;color:#1D1D1F;font-size:13px;font-weight:700}' +
    '@media (hover:hover){' + ROW + '{cursor:grab}}';
  (doc.head || doc.documentElement).appendChild(css);

  var s = null; /* the swipe in progress */

  function removeBtn(row) {
    var all = row.querySelectorAll('[data-action="decrease-quantity"][data-quantity="0"]');
    for (var i = 0; i < all.length; i++) if (all[i].offsetParent) return all[i];
    return all[0] || null;
  }
  function makeBg(row) {
    var list = row.parentNode;
    if (getComputedStyle(list).position === 'static') list.style.position = 'relative';
    var bg = doc.createElement('div'); bg.className = 'brf-swipe-bg';
    bg.innerHTML = '<span class="brf-swipe-bg__in brf-swipe-bg__rm">' + BIN + '<span>Remove</span></span>'
      + '<span class="brf-swipe-bg__in brf-swipe-bg__wl">' + HEART + '<span>Save to wishlist</span></span>';
    bg.style.top = row.offsetTop + 'px'; bg.style.left = row.offsetLeft + 'px';
    bg.style.width = row.offsetWidth + 'px'; bg.style.height = row.offsetHeight + 'px';
    list.insertBefore(bg, row);
    return bg;
  }
  function setX(x) {
    s.x = x;
    s.row.style.transform = 'translateX(' + x + 'px)';
    var w = s.row.offsetWidth, armed = Math.abs(x) > w * (x > 0 ? 0.25 : 0.35);
    s.bg.classList.toggle('is-l', x < 0); s.bg.classList.toggle('is-r', x > 0);
    if (armed !== s.armed) { s.armed = armed; s.bg.classList.toggle('is-armed', armed); if (armed && navigator.vibrate) try { navigator.vibrate(8); } catch (e) {} }
  }
  function cleanup(row, bg) {
    row.classList.remove('is-swiping'); row.style.transition = ''; row.style.transform = '';
    if (bg && bg.parentNode) bg.parentNode.removeChild(bg);
  }

  doc.addEventListener('pointerdown', function (e) {
    if (s || (e.pointerType === 'mouse' && e.button !== 0)) return;
    var row = e.target.closest && e.target.closest(ROW);
    if (!row || e.target.closest('input, .quantity-selector')) return;
    s = { row: row, id: e.pointerId, x0: e.clientX, y0: e.clientY, x: 0, t0: Date.now(), on: false, armed: false, pts: [] };
  }, true);

  doc.addEventListener('pointermove', function (e) {
    if (!s || e.pointerId !== s.id) return;
    var dx = e.clientX - s.x0, dy = e.clientY - s.y0;
    if (!s.on) {
      if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { s = null; return; } /* scrolling */
      if (Math.abs(dx) < 8) return;
      s.on = true; s.bg = makeBg(s.row);
      s.row.classList.add('is-swiping'); s.row.classList.remove('brf-swipe-hint');
      try { s.row.setPointerCapture(e.pointerId); } catch (er) {}
    }
    e.preventDefault();
    s.lastX = dx; s.lastT = Date.now();
    s.pts.push([dx, s.lastT]); if (s.pts.length > 6) s.pts.shift();
    setX(dx);
  }, { passive: false, capture: true });
  /* while a row is being swiped, keep the bag list from scrolling (a curved thumb swipe used to turn into a scroll and the
     phone then cancelled the swipe) */
  doc.addEventListener('touchmove', function (e) { if (s && s.on && e.cancelable) e.preventDefault(); }, { passive: false, capture: true });

  function end(e) {
    if (!s || e.pointerId !== s.id) return;
    var c = s; s = null;
    if (!c.on) return;
    var w = c.row.offsetWidth, p0 = c.pts[0] || [0, c.t0], p1 = c.pts[c.pts.length - 1] || [c.x, Date.now()];
    var v = (p1[0] - p0[0]) / Math.max(1, p1[1] - p0[1]); /* px per ms over the last few moves */
    var flick = Math.abs(c.x) > 50 && Math.abs(v) > 0.45 && (v > 0) === (c.x > 0);
    /* a drag is not a click: swallow the click that follows it */
    var k = function (ev) { ev.stopPropagation(); ev.preventDefault(); doc.removeEventListener('click', k, true); };
    doc.addEventListener('click', k, true);
    setTimeout(function () { doc.removeEventListener('click', k, true); }, 350); /* touch swipes usually send no click */
    if (c.armed || flick) {
      if (c.x > 0) saveWl(c); /* a save is harmless, so it counts even if the phone cancelled the swipe at the end */
      else if (e.type !== 'pointercancel') commit(c, -1, w);
      else back(c);
    } else back(c);
  }
  doc.addEventListener('pointerup', end, true);
  doc.addEventListener('pointercancel', end, true);

  function back(c) {
    c.row.style.transition = reduce ? 'none' : 'transform .45s cubic-bezier(.3,1.35,.45,1)';
    c.row.style.transform = 'translateX(0)';
    c.bg.style.transition = 'opacity .3s ease'; c.bg.style.opacity = '0';
    setTimeout(function () { cleanup(c.row, c.bg); }, reduce ? 0 : 460);
  }
  /* left to right: add to the wishlist, keep the item in the bag */
  function handleOf(row) {
    var a = row.querySelector('a[href*="/products/"]'), m = a && /\/products\/([^\/?#]+)/.exec(a.getAttribute('href') || '');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function wlNote(text) {
    var el = doc.querySelector('.brf-swipe-wl');
    if (!el) { el = doc.createElement('a'); el.className = 'brf-swipe-wl'; el.href = '/pages/wishlist'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); doc.body.appendChild(el); }
    el.innerHTML = HEART + '<span>' + text + '</span><b>View</b>';
    el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
    clearTimeout(el.__t); el.__t = setTimeout(function () { el.classList.remove('is-in'); }, 2800);
  }
  function saveWl(c) {
    var h = handleOf(c.row), wl = window.brfWl;
    if (!h || !wl) { back(c); return; }
    var had = wl.list().indexOf(h) > -1;
    if (!had) wl.add(h);
    if (navigator.vibrate) try { navigator.vibrate(10); } catch (e) {}
    c.bg.classList.add('is-armed', 'is-saved');
    setTimeout(function () { back(c); }, reduce ? 0 : 420);
    wlNote(had ? 'Already in your wishlist' : 'Saved to your wishlist');
  }
  function commit(c, dir, w) {
    var row = c.row, bg = c.bg, btn = removeBtn(row);
    if (!btn) { back(c); return; }
    bg.classList.add('is-armed');
    if (window.brfVanish) { window.brfVanish(row, btn, { from: c.x, bg: bg }); return; }
    row.style.transition = 'transform .26s ease, opacity .26s ease';
    row.style.transform = 'translateX(' + dir * (w + 40) + 'px)'; row.style.opacity = '0';
    setTimeout(function () { if (bg.parentNode) bg.parentNode.removeChild(bg); btn.click(); }, 280);
  }

  /* first time the bag opens with something in it (once per visit): the top row nudges left to show it can be swiped */
  function hint() {
    try { if (sessionStorage.getItem('brfSwipeHint')) return; } catch (e) { return; }
    var row = doc.querySelector(ROW); if (!row || !row.offsetParent || reduce) return;
    try { sessionStorage.setItem('brfSwipeHint', '1'); } catch (e) {}
    var bg = makeBg(row); bg.classList.add('is-l');
    row.style.background = '#fff'; row.style.borderRadius = '16px'; row.style.zIndex = '2';
    row.classList.add('brf-swipe-hint');
    setTimeout(function () { row.classList.remove('brf-swipe-hint'); row.style.background = ''; row.style.borderRadius = ''; row.style.zIndex = ''; if (bg.parentNode) bg.parentNode.removeChild(bg); }, 1600);
  }
  var mc = null;
  function watch() {
    var m = doc.querySelector('#mini-cart'); if (!m || m === mc) return; mc = m;
    var last = m.getAttribute('aria-hidden');
    new MutationObserver(function () {
      var now = m.getAttribute('aria-hidden');
      if (last === 'true' && now === 'false') {
        /* brf-mc-apple.css: rows drift in one after another, only while the bag is opening */
        m.classList.add('brf-mc-in'); setTimeout(function () { m.classList.remove('brf-mc-in'); }, 900);
        setTimeout(hint, 450);
      }
      last = now;
    }).observe(m, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', watch); else watch();
  window.addEventListener('load', watch);
})();

/* ---- Slide-away delete (2026-10-24, Abid) ----
   Removing an item from the bag drawer (swipe left, the bin at quantity 1, or "Remove") or from the desktop bag popup no longer
   just blinks out: the row slips sideways, softens and shrinks, a small puff of light rises where it was, and the items below
   glide up to close the gap. Only then is the theme's own remove pressed, so the Undo note (brf-cart-bin) still works. */
(function () {
  if (window.__brfVanish) return; window.__brfVanish = 1;
  var doc = document, reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var st = doc.createElement('style');
  st.textContent =
    '.brf-vanish{pointer-events:none!important;overflow:hidden!important;will-change:transform,opacity,height}' +
    '.brf-vanish *{pointer-events:none!important}' +
    '.brf-puff{position:fixed;z-index:2147483002;width:0;height:0;pointer-events:none}' +
    '.brf-puff i{position:absolute;left:-3px;top:-3px;width:6px;height:6px;border-radius:50%;opacity:0;' +
      'background:radial-gradient(circle,#fff 0,rgba(255,255,255,.9) 35%,rgba(20,153,84,.55) 70%,rgba(20,153,84,0) 100%);' +
      'box-shadow:0 0 8px rgba(20,153,84,.45);animation:brfPuff .75s cubic-bezier(.2,.8,.2,1) forwards}' +
    '@keyframes brfPuff{0%{opacity:0;transform:translate(0,0) scale(.4)}20%{opacity:1}100%{opacity:0;transform:translate(var(--dx),var(--dy)) scale(1.1)}}';
  (doc.head || doc.documentElement).appendChild(st);

  function puff(x, y) {
    if (reduce) return;
    var p = doc.createElement('span'); p.className = 'brf-puff'; p.style.left = x + 'px'; p.style.top = y + 'px';
    for (var i = 0; i < 9; i++) {
      var a = (Math.PI * 2 * i) / 9 + Math.random() * 0.5, d = 16 + Math.random() * 22, dot = doc.createElement('i');
      dot.style.setProperty('--dx', Math.cos(a) * d + 'px'); dot.style.setProperty('--dy', (Math.sin(a) * d - 14) + 'px');
      dot.style.animationDelay = (Math.random() * 90) + 'ms';
      var z = 4 + Math.random() * 5; dot.style.width = dot.style.height = z + 'px';
      p.appendChild(dot);
    }
    doc.body.appendChild(p);
    setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 950);
  }

  /* row: the line to remove; btn: the theme control that removes it; o.from: how far a swipe already moved it */
  function vanish(row, btn, o) {
    o = o || {};
    if (row.__brfGone) return; row.__brfGone = 1;
    var r = row.getBoundingClientRect(), from = o.from || 0, dir = from > 0 ? 1 : -1;
    var go = function () { row.__brfPass = 1; try { btn.click(); } finally { row.__brfPass = 0; } };
    if (reduce) { if (o.bg && o.bg.parentNode) o.bg.parentNode.removeChild(o.bg); go(); return; }
    row.classList.add('brf-vanish');
    /* 1. slip out: a swipe carries on from where the finger let go, a tap nudges the row left */
    var out = from ? dir * (r.width * 0.9) : -Math.min(90, r.width * 0.28);
    row.style.transition = 'transform .32s cubic-bezier(.4,0,.2,1), opacity .3s ease, filter .3s ease';
    row.style.transform = 'translateX(' + out + 'px) scale(.94)'; row.style.opacity = '0'; row.style.filter = 'blur(3px)';
    puff(r.left + r.width * (from ? (dir > 0 ? 0.75 : 0.25) : 0.5), r.top + r.height / 2);
    if (o.bg) { o.bg.style.transition = 'opacity .35s ease'; o.bg.style.opacity = '0'; }
    /* 2. fold: the items below glide up into the space */
    setTimeout(function () {
      var h = row.offsetHeight;
      row.style.height = h + 'px'; row.style.minHeight = '0px';
      void row.offsetHeight;
      row.style.transition = 'height .42s cubic-bezier(.32,.72,0,1), margin .42s cubic-bezier(.32,.72,0,1), padding .42s cubic-bezier(.32,.72,0,1), border-width .42s ease';
      row.style.height = '0px'; row.style.marginTop = '0px'; row.style.marginBottom = '0px';
      row.style.paddingTop = '0px'; row.style.paddingBottom = '0px'; row.style.borderTopWidth = '0px'; row.style.borderBottomWidth = '0px';
      setTimeout(function () { if (o.bg && o.bg.parentNode) o.bg.parentNode.removeChild(o.bg); go(); }, 400);
    }, 250);
  }
  window.brfVanish = vanish;

  /* taps on the bin / Remove: run the slide-away first, then press the same control again for real */
  var DRAWER = '#mini-cart .mini-cart__line-item [data-action="decrease-quantity"][data-quantity="0"], #mini-cart .mini-cart__line-item .mini-cart__quantity-remove';
  window.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var b = t.closest(DRAWER), row = b && b.closest('.mini-cart__line-item');
    if (!row) {
      /* desktop glass-header popup: a minus that takes the line to 0, or its bin */
      b = t.closest('#brf-hc-bag .brf-hc__bag-li [data-bq]'); row = b && b.closest('.brf-hc__bag-li');
      if (row) {
        var n = parseInt(row.getAttribute('data-q'), 10), d = parseInt(b.getAttribute('data-bq'), 10);
        if (!(d === 0 || (!isNaN(n) && n + d <= 0))) row = null;
      }
    }
    if (!row || row.__brfPass) return;
    e.preventDefault(); e.stopImmediatePropagation();
    vanish(row, b);
  }, true);
})();

/* ---- Mini bag panel: proper frosted glass so the bag reads clearly over busy banners (2026-10-23, Abid) ----
   The page behind showed through the 93%-white panel (sharpest over the Christmas banner on phones) because the header bar's
   own frosted blur stops the panel's blur from reaching the page. Now: while the bag is open the header bar's blur is paused,
   the panel blurs the page strongly and sits on a 97.5% warm-white fill, so text and prices read easily but it still feels like
   glass. */
(function () {
  if (window.__brfMcFrost) return; window.__brfMcFrost = 1;
  var css = 'html:has(#mini-cart[aria-hidden="false"]) .shopify-section-group-header-group{-webkit-backdrop-filter:none!important;backdrop-filter:none!important}'
    + 'html body #mini-cart.mini-cart.brf-mc{background:linear-gradient(180deg,rgba(255,255,255,.975),rgba(250,248,245,.975))!important;'
    + '-webkit-backdrop-filter:blur(40px) saturate(160%)!important;backdrop-filter:blur(40px) saturate(160%)!important;will-change:auto!important}';
  var st = document.createElement('style'); st.id = 'brf-mc-frost'; st.textContent = css;
  (document.head || document.documentElement).appendChild(st);
})();
